import { render, staticRenderFns } from "./MarketOrder.vue?vue&type=template&id=cc70fe52&scoped=true"
import script from "./MarketOrder.vue?vue&type=script&lang=js"
export * from "./MarketOrder.vue?vue&type=script&lang=js"
import style0 from "./MarketOrder.vue?vue&type=style&index=0&id=cc70fe52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc70fe52",
  null
  
)

export default component.exports